<template>

    <div>
        <!-- Page header: identita' Limitless come le altre dashboard -->
        <div class="page-header page-header-light shadow">
            <div class="page-header-content d-lg-flex">
                <div class="d-flex">
                    <h6 class="page-title mb-0">
                        <span class="text-muted">Dashboard</span>
                    </h6>
                </div>
                <div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="dm_page_header">
                    <div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
                        <span class="btn btn-light" v-if="periodo">
                            Periodo: <span class="ms-1">{{ periodoLabel }}</span>
                        </span>
                        <div class="vr flex-shrink-0 my-2 mx-3 d-none d-lg-block"></div>
                        <!-- B2.1C-01B: toggle filtri. Toccando cambia SOLO lo stato UI:
                             nessuna chiamata Dashboard, nessuna applicazione, nessun reset. -->
                        <button type="button" class="btn btn-outline-light btn-filter-dash" @click="toggleFiltri"
                                :aria-expanded="filtriAperti ? 'true' : 'false'" aria-controls="dm_pannello_filtri">
                            <i class="ph me-1" :class="filtriAperti ? 'ph-funnel' : 'ph-funnel'" aria-hidden="true"></i>{{ filtriAperti ? 'Chiudi filtri' : 'Filtri avanzati' }}
                        </button>
                        <!-- DASH-CUSTOM-05 (correzione UX autorizzata): l'entry
                             point di personalizzazione NON vive piu' qui: la
                             toolbar filtri contiene SOLO periodo + filtri (SYSTEM
                             UI). Il pulsante e' stato spostato nella zona Welcome. -->
                        <!-- B2.1C-01C-B A: il pulsante Aggiorna e' stato rimosso.
                             carica() resta usato da created(), Riprova e Applica. -->
                    </div>
                </div>
            </div>
        </div>

        <div class="content content-1">

            <!-- Stato PARTIAL: visibile, non silenzioso -->
            <div class="alert alert-warning d-flex align-items-start" role="alert" v-if="dataStatus === 'PARTIAL'">
                <i class="ph ph-warning me-2 mt-1" aria-hidden="true"></i>
                <div>
                    <strong>Dati parziali.</strong>
                    Alcuni blocchi non sono disponibili per questa richiesta.
                    I blocchi mancanti sono mostrati come "non disponibili", non come zero.
                    <div v-if="errori.length" class="font-size-sm mt-1">
                        Blocchi interessati: {{ blocchiInErrore }}
                    </div>
                </div>
            </div>

            <!-- Stato ERROR: nessun KPI mostrato come zero -->
            <div class="card" v-if="dataStatus === 'ERROR'">
                <div class="card-body text-center py-5">
                    <i class="ph ph-warning-circle text-danger fs-1" aria-hidden="true"></i>
                    <h5 class="mt-3">Dati della dashboard non disponibili</h5>
                    <p class="text-muted mb-4">
                        Il calcolo dei dati principali non è andato a buon fine.
                        Nessun valore viene mostrato, per non presentare dati mancanti come se fossero zero.
                    </p>
                    <div class="font-size-sm text-muted mb-3" v-if="errori.length">
                        <span v-for="(e, i) in errori" :key="i" class="d-block">
                            {{ e.blocco }}<span v-if="e.codice"> — codice {{ e.codice }}</span>
                        </span>
                    </div>
                    <button type="button" class="btn btn-primary" @click="carica">
                        <i class="ph ph-arrow-clockwise me-1" aria-hidden="true"></i>Riprova
                    </button>
                </div>
            </div>

            <!-- Stato tecnico: contract non riconosciuto -->
            <div class="card" v-else-if="erroreContratto">
                <div class="card-body text-center py-5">
                    <i class="ph ph-file-dashed text-warning fs-1" aria-hidden="true"></i>
                    <h5 class="mt-3">Versione del contratto non compatibile</h5>
                    <p class="text-muted mb-4">
                        Questa interfaccia è scritta per la versione
                        <code>{{ CONTRACT_VERSION }}</code> del contratto.
                        <span v-if="contractoRicevuto">Il server ha risposto con
                            <code>{{ contractoRicevuto }}</code>.</span>
                        <span v-else>Il server non ha indicato alcuna versione del contratto.</span>
                    </p>
                    <button type="button" class="btn btn-outline-primary" @click="carica">Riprova</button>
                </div>
            </div>

            <template v-else>
                <!-- Warning strutturati: si preferisce warning[], avvisi[] solo come fallback -->
                <div class="alert alert-info py-2" role="alert" v-for="(w, i) in warningVisibili" :key="'w' + i">
                    <span v-if="typeof w !== 'string'">
                        <strong>{{ w.severity === 'warning' ? 'Attenzione' : 'Nota' }}:</strong> {{ w.message }}
                    </span>
                    <span v-else>{{ w }}</span>
                </div>

                <!-- B2.1C-01B: pannello filtri CHIUSO di default.
                     v-show mantiene il pannello montato: la bozza sopravvive
                     a apertura/chiusura. Il toggle non chiama mai carica(). -->
                <Transition name="dm-filter">
                    <div v-show="filtriAperti" id="dm_pannello_filtri">
                        <ManagerFilterBar :applicati="filtriPerBarra"
                                          :filtri-espliciti="filtriEspliciti"
                                          :stati-chiusi="statiChiusi"
                                          @applica="applicaFiltri"
                                          @reset-filtri="resetFiltri"
                                          @chiudi="toggleFiltri" />
                    </div>
                </Transition>

                <!-- DASH-CUSTOM-05: barra della modalita' personalizzazione.
                     Esiste SOLO in edit mode: fuori da edit la dashboard non ha
                     nessun controllo di personalizzazione. Salva/Annulla/Ripristina
                     passano ESCLUSIVAMENTE dal motore Stage C (salvaLayout /
                     resetLayout); Annulla non effettua NESSUNA chiamata. -->
                <div class="card dm-edit-bar" v-if="editMode">
                    <div class="card-body py-2 d-flex flex-wrap align-items-center gap-2">
                        <span class="fw-bold me-auto">
                            <i class="ph ph-sliders-horizontal me-1" aria-hidden="true"></i>Personalizzazione dashboard
                        </span>
                        <!-- Elenco COMPLETO dei widget del registry (whitelist): qui
                             si riattiva anche un widget disattivato, che non essendo
                             renderizzato non ha un proprio interruttore. -->
                        <div class="dropdown">
                            <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="ph ph-layout me-1" aria-hidden="true"></i>Widget
                            </button>
                            <div class="dropdown-menu dropdown-menu-end dm-widget-menu px-3">
                                <div v-for="w in widgetVociEdit" :key="'dm-w-' + w.id" class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                           :id="'dm-widget-' + w.id" :checked="w.abilitato"
                                           @change="toggleWidgetEdit(w.id)">
                                    <label class="form-check-label font-size-sm" :for="'dm-widget-' + w.id">{{ w.etichetta }}</label>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary"
                                :disabled="!draftDirty || layoutSaving || layoutResetting"
                                @click="salvaDalDraft">
                            <i class="ph ph-floppy-disk me-1" aria-hidden="true"></i>Salva
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                :disabled="layoutSaving || layoutResetting" @click="annullaEdit">Annulla</button>
                        <button type="button" class="btn btn-sm btn-outline-danger"
                                :disabled="layoutSaving || layoutResetting" @click="ripristinaDefault">
                            <i class="ph ph-arrow-counter-clockwise me-1" aria-hidden="true"></i>Ripristina default
                        </button>
                    </div>
                    <!-- Conflitto Stage C (LAYOUT_CONFLICT): nessun retry, nessun
                         overwrite, nessun reset automatico. Il draft resta preservato
                         e la decisione spetta all'utente. -->
                    <div class="alert alert-warning mb-0 px-3 py-2" role="alert" v-if="layoutConflitto">
                        <strong>Conflitto di versione.</strong>
                        Il layout è stato modificato altrove (revisione server
                        {{ layoutConflitto.current_revision === null ? 'sconosciuta' : layoutConflitto.current_revision }}).
                        Le modifiche non salvate sono state preserve: puoi riprovare il salvataggio, annullare o ripristinare il default.
                    </div>
                    <div class="alert alert-info mb-0 px-3 py-2" role="alert" v-if="editAvviso">{{ editAvviso }}</div>
                </div>

                <!-- DASH-CUSTOM-06F - RENDERER GRID A 12 COLONNE. Welcome SYSTEM
                     pinnata in alto-sinistra (5/12), fuori dal flusso draggable.
                     Gli altri widget alla posizione position {row,column,rowSpan};
                     larghezza da widgets[k].span. Drag HTML5 nativo in edit mode;
                     collisioni risolte da compattazione deterministica. -->
                <div class="dm-grid" ref="dmGrid" @dragover.prevent="onDragOver" @drop.prevent="onDrop">
                    <!-- Welcome SYSTEM: fissa, non draggable, non toggleabile. -->
                    <div class="dm-widget dm-cell dm-widget--pinned" data-dm-widget="welcome" :style="stileCella(welcomePos)">
                        <WelcomeCard :nome="utenteNome" :avatar="utenteAvatar" />
                        <div class="dm-system-welcome-actions" v-if="puoPersonalizzare">
                            <button type="button" class="btn btn-light" @click="entraInEdit">
                                <i class="ph ph-sliders-horizontal me-1" aria-hidden="true"></i>Personalizza<span class="dm-personalize-label-suffix"> dashboard</span>
                            </button>
                        </div>
                    </div>
                    <!-- Coppia DEFAULT: un solo contenitore 7/12, due widget distinti.
                         Fuori dal DEFAULT ciascun widget torna nella griglia individuale. -->
                    <div v-if="mostraCoppiaDestra" class="dm-cell dm-first-row-right"
                         :style="{ gridColumn: '6 / span 7', gridRow: '1 / span 2' }">
                        <div v-for="id in ['project_status', 'activity']" :key="'pair-' + id"
                             class="dm-widget dm-pair-item" :data-dm-widget="id"
                             :class="{ 'dm-dragging': dragId === id }"
                             :draggable="editMode && !layoutSaving && !layoutResetting"
                             @dragstart="onDragStart($event, id)" @dragend="onDragEnd">
                            <div class="dm-widget-tools" v-if="editMode">
                                <span class="dm-drag-handle" title="Trascina per spostare"><i class="ph ph-dots-six" aria-hidden="true"></i></span>
                                <div class="form-check form-switch mb-0">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                           :id="'dm-sw-' + id" :checked="true"
                                           @change="toggleWidgetEdit(id)" aria-label="Disattiva widget" />
                                </div>
                            </div>
                            <ProjectStatusCard v-if="id === 'project_status'" class="w-100"
                                               :stati="stati" :progetti="progettiElenco"
                                               :loading="caricamento && !datiPrecedenti" :max-progetti="5"
                                               @apri-progetto="apriSchedaProgetto" />
                            <ActivityPanel v-else class="w-100" :scroll="true" />
                        </div>
                    </div>
                    <!-- Widget personalizzabili alla propria cella di griglia. -->
                    <div v-for="w in widgetSingoli" :key="'g-' + w.id"
                         class="dm-widget dm-cell dm-widget-item" :data-dm-widget="w.id"
                         :class="{ 'dm-dragging': dragId === w.id, 'dm-widget--heatmap': w.id === 'heatmap', 'dm-widget--kpi': w.id === 'kpi' }"
                         :style="stileCella(w)"
                         :draggable="editMode && !layoutSaving && !layoutResetting"
                         @dragstart="onDragStart($event, w.id)" @dragend="onDragEnd">
                        <div class="dm-widget-tools" v-if="editMode">
                            <span class="dm-drag-handle" title="Trascina per spostare"><i class="ph ph-dots-six" aria-hidden="true"></i></span>
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" role="switch"
                                       :id="'dm-sw-' + w.id" :checked="true"
                                       @change="toggleWidgetEdit(w.id)" aria-label="Disattiva widget" />
                            </div>
                        </div>

                        <ProjectStatusCard v-if="w.id === 'project_status'" class="w-100"
                                           :stati="stati" :progetti="progettiElenco"
                                           :loading="caricamento && !datiPrecedenti" :max-progetti="5"
                                               @apri-progetto="apriSchedaProgetto" />
                        <ActivityPanel v-else-if="w.id === 'activity'" class="w-100" :scroll="true" />

                        <div v-else-if="w.id === 'kpi'" class="row g-2 ui02-kpi-grid w-100">
                            <!-- KPI-04B: quattro KPI economiche dal blocco additivo
                                 data.economia. Nessun ricalcolo nel frontend: il
                                 valore mostrato e' quello aggregato dal backend. -->
                            <div v-for="k in kpiPrimariQuattro" :key="'ui02-' + k.chiave" class="col-6">
                                <KpiCard :label="k.label" :icona="k.icona" :tema="temaKpi(k.chiave)"
                                         :indicatore="indicatoreEconomia(k.chiave)"
                                         :secondario="secondarioKpi(k.chiave)"
                                         :nota="notaKpi(k.chiave)"
                                         :non-applicabile="kpiNonApplicabile(k.chiave)"
                                         :cliccabile="kpiEconomicoCliccabile(k.chiave)"
                                         :loading="caricamento && !datiPrecedenti"
                                         @apri="apriKpiEconomico(k.chiave)" />
                            </div>
                        </div>

                        <TrendChart v-else-if="w.id === 'trend'" class="w-100"
                                    :trend="trend" :loading="caricamento && !datiPrecedenti" />

                        <!-- UI-06: placeholder indipendente, nessun dato inventato. -->
                        <InSviluppoCard v-else-if="w.id === 'in_sviluppo'" class="w-100" />

                        <HeatmapGrid v-else-if="w.id === 'heatmap'"
                                     :heatmap="heatmap" :loading="caricamento && !datiPrecedenti"
                                     :filtri="filtriPerBarra" :periodo="periodoLabel"
                                     @drill="apriDrillHeatmap" />

                        <RankingsPanel v-else-if="w.id === 'rankings'" class="w-100"
                                       :rankings="rankings" :loading="caricamento && !datiPrecedenti"
                                       :max-righe="10" />

                        <SupplierSpendCard v-else-if="w.id === 'supplier_spend'" class="w-100"
                                           :spese="speseFornitore" :loading="caricamento && !datiPrecedenti"
                                           :periodo="periodoLabel" :filtri="filtriPerBarra"
                                           :fixed-height="420" />

                        <RecentPanel v-else-if="w.id === 'recent'" class="w-100"
                                     :recent="recent" :loading="caricamento && !datiPrecedenti" />
                    </div>
                </div>

                <!-- UI-07: drill del mese. Stesso perimetro della heatmap perche'
                     riceve gli stessi filtri (filtriPerBarra). -->
                <HeatmapDrillModal :aperto="heatmapDrill.aperta" :mese="heatmapDrill.mese"
                                   :metrica="heatmapDrill.metrica" :periodo="periodoLabel"
                                   :filtri="filtriPerBarra" @chiudi="chiudiDrillHeatmap" />

                <!-- KPI-04B: dettaglio delle quattro KPI economiche. Nessuna
                     chiamata API: usa le righe gia' autorizzate nel payload. -->
                <KpiDetailModal :aperto="kpiEconomico.aperto" :tipo="kpiEconomico.tipo"
                                :economia="economia" :periodo="periodo"
                                :filtri="filtriPerBarra"
                                @chiudi="chiudiKpiEconomico" />

                <!--<p class="text-muted font-size-sm mt-3 mb-0" v-if="meta.contract_version">
                    Contratto {{ meta.contract_version }} · generato {{ meta.generated_at || '—' }} ({{ meta.timezone || '—' }})
                </p>-->
            </template>

        </div>

        <!-- Scheda informativa progetto: offcanvas dedicato, non altera i filtri dashboard. -->
        <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="dm_project_details"
             data-bs-backdrop="false" role="dialog" tabindex="-1"
             aria-labelledby="dm_project_details_title">
            <div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
                <h5 id="dm_project_details_title" class="modal-title modal-title-width">
                    <i class="ph-list icon-modal-size me-2"></i>Scheda Informativa
                </h5>
                <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
                        data-bs-dismiss="offcanvas" aria-label="Chiudi">
                    <i class="ph-x icon-x-size"></i>
                </button>
            </div>
            <div class="offcanvas-body p-2">
                <SchedaVisualizzazioneProgetto ref="schedaVisualizzazioneProgettoDashboard" />
            </div>
            <div class="border-top p-1 bg-light">
                <button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">Chiudi</button>
            </div>
        </div>

        <!-- B2.2A.1-R: drawer drill-down READ-ONLY. NON e' una navigazione: aprire o
             chiudere non tocca i 7 filtri, il breadcrumb, il periodo e non ricarica
             la Dashboard. Chiudere riporta allo stato esatto precedente. -->
        <DrillDownDrawer :aperto="!!drilldown.stato"
                         :contesto="filtriEspliciti"
                         :stato="drilldown.stato"
                         @chiudi="chiudiDrillDown" />
    </div>
    
</template>


<script>
import KpiCard from "@/components/dashboard/KpiCard.vue";
import WelcomeCard from "@/components/dashboard/WelcomeCard.vue";
import ProjectStatusCard from "@/components/dashboard/ProjectStatusCard.vue";
import SchedaVisualizzazioneProgetto from "@/components/SchedaVisualizzazioneProgetto.vue";
import ActivityPanel from "@/components/dashboard/ActivityPanel.vue";
import TrendChart from "@/components/dashboard/TrendChart.vue";
import HeatmapGrid from "@/components/dashboard/HeatmapGrid.vue";
import RankingsPanel from "@/components/dashboard/RankingsPanel.vue";
import SupplierSpendCard from "@/components/dashboard/SupplierSpendCard.vue";
import RecentPanel from "@/components/dashboard/RecentPanel.vue";
import ManagerFilterBar from "@/components/dashboard/ManagerFilterBar.vue";
import DrillDownDrawer from "@/components/dashboard/DrillDownDrawer.vue";
import InSviluppoCard from "@/components/dashboard/InSviluppoCard.vue";
import HeatmapDrillModal from "@/components/dashboard/HeatmapDrillModal.vue";
import KpiDetailModal from "@/components/dashboard/KpiDetailModal.vue";
/* DASH-CUSTOM-06D: il runtime usa il NORMALIZER V2 (order + span) come fonte
 * semantica unica. Legge sia risposte schema 1 (migrate IN MEMORIA a V2) sia
 * schema 2. authorizedKeys ASSENTE = "tutto autorizzato": la restrizione reale
 * e' applicata dal SERVER (contratto foundation invariato). */
import { normalizeDashboardLayoutV2 } from "@/config/dashboard/dashboardLayoutV2";
/* DASH-CUSTOM-05: il registry diventa la whitelist del rendering dinamico. */
import { WIDGET_REGISTRY_V1 } from "@/config/dashboard/widgetRegistry";
/* DASH-CUSTOM-06F: posizioni DEFAULT della griglia + proiezione legacy->grid. */
import { DEFAULT_MANAGER_V2_GRID_POSITIONS } from "@/config/dashboard/dashboardDefaults";
import { projectZonePositionToGrid } from "@/config/dashboard/dashboardLayoutV2";
/* DASH-CUSTOM-06F — RENDERER GRID + DRAG NATIVO HTML5 (nessuna dipendenza).
 * La griglia a 12 colonne sostituisce le tre zone 06E: il drag in edit mode
 * aggiorna position e span dei soli widget coinvolti nello scambio;
 * order/enabled/authorization/persistence restano INTATTI. Fuori da
 * edit mode nessuna cella e' draggable. vue-draggable-next non e' piu' usato
 * da questo componente (era il motore della lista piatta 06E). */

const API = "theb/dashboard/manager";
/* Unica versione di contratto accettata. */
const CONTRACT_VERSION = "2.1.0";

/* DASH-CUSTOM-05 — zone di layout V1: membership FISSA per whitelist.
 * La geometria default nasce da questi gruppi + classi colonna originali:
 * nessuno span configurabile, nessun grid engine, nessun componente
 * risolto da stringhe arbitrarie (solo registry -> mapping esplicito).
 *
 * DASH-CUSTOM-05 (correzione UX autorizzata): WELCOME e FILTERBAR sono
 * SYSTEM UI e NON sono personalizzabili. WELCOME resta nel registry/
 * default/normalizer (e nel contratto server V1: registryV1 lo include)
 * per BACKWARD COMPATIBILITY, ma il frontend NON lo espone all'utente.
 * PERSISTENCE COMPATIBILITY != PERSONALIZABLE UI. */
/* DASH-CUSTOM-06D — NESSUNA zona fissa. Il rendering e' un ORDINE PIATTO
 * (layout.order) filtrato per authorized/enabled/personalizable, disposto su
 * una CSS Grid a 12 colonne; la larghezza deriva dallo span canonico V2.
 *
 * DASH-CUSTOM-05 (correzione UX): WELCOME e FILTERBAR sono SYSTEM UI e NON
 * personalizzabili. WELCOME resta nel registry/default/normalizer (e nel
 * contratto server: registryV1 lo include) per BACKWARD COMPATIBILITY, ma il
 * frontend NON lo espone all'utente.
 * PERSISTENCE COMPATIBILITY != PERSONALIZABLE UI. */
const WIDGET_SISTEMA = Object.freeze(["welcome"]);
/* I 9 widget PERSONALIZZABILI: derivati dal REGISTRY (whitelist reale)
 * meno i SYSTEM UI. Ordine = canonico del registry. DASH-CUSTOM-06F:
 * in_sviluppo e' ora un widget indipendente (ex placeholder annidato). */
const WIDGET_PERSONALIZZABILI = Object.freeze(
    WIDGET_REGISTRY_V1.keys().filter((k) => WIDGET_SISTEMA.indexOf(k) === -1)
);
/* DASH-CUSTOM-06F — le zone left/right/free appartengono al formato position
 * LEGACY {zone,row,rank} (06E): sono accettate SOLO in lettura dei vecchi
 * layout salvati e proiettate IN MEMORIA nella griglia a 12 colonne
 * (projectZonePositionToGrid). Non vengono piu' mai scritte. */
const ZONES = Object.freeze(["left", "right", "free"]);
const ETICHETTE_WIDGET = Object.freeze({
    welcome: "Benvenuto",
    kpi: "Indicatori (KPI)",
    project_status: "Stato dei progetti",
    activity: "Attività e notifiche",
    trend: "Andamento del periodo",
    in_sviluppo: "In sviluppo",
    heatmap: "Mappa progetti",
    rankings: "Classifiche",
    supplier_spend: "Spese per fornitore",
    recent: "Movimenti recenti",
});

export default {
    name: "DashboardManager",

    components: {
        KpiCard, WelcomeCard, ProjectStatusCard, ActivityPanel, TrendChart, HeatmapGrid,
        RankingsPanel, SupplierSpendCard, RecentPanel, ManagerFilterBar, DrillDownDrawer,
        InSviluppoCard, HeatmapDrillModal, SchedaVisualizzazioneProgetto, KpiDetailModal,
    },

    data() {
        return {
            CONTRACT_VERSION,
            /* Payload grezzo: null = mai caricato, null di un blocco = non disponibile. */
            payload: null,
            meta: {},
            periodo: null,
            filtri: null,
            warning: [],
            avvisi: [],
            errori: [],
            dataStatus: null,
            contrattoRicevuto: null,
            erroreContratto: false,
            caricamento: false,
            filtriAperti: false,   // B2.1C-01B: pannello CHIUSO di default, nessuna persistenza
            datiPrecedenti: false,
            /* Filtri in bozza: non inviati finche' non si preme "Applica". */
            filtriDaInviare: {},
            /* B2.1C-01D: filtri posti ESPLICITAMENTE dall'utente. Un reload senza
               filtri (Reset, o primo caricamento) li azzera: il riepilogo del filtro
               non deve mostrare il periodo di default restituito dal backend. */
            filtriEspliciti: {},
            /* B2.1C-01E/02: stato del drawer di drill-down (null = chiuso). */
            drilldown: { stato: null },
            /* UI-07: drill del mese della heatmap. */
            heatmapDrill: { aperta: false, mese: "", metrica: "fatturato" },
            /* KPI-04B: modale di dettaglio economico. aperta/tipo sono SOLO stato
               di presentazione: nessuna chiamata API, nessun filtro modificato. */
            kpiEconomico: { aperto: false, tipo: "" },
            /* DASH-CUSTOM-04 Stage B: SERVER STATE layout persistito (READ ONLY).
               Nessuno stato di salvataggio/drag/dirty: Stage B non scrive. */
            layoutPersonalizzato: null,  // config normalizzato (o default in fallback)
            layoutRevision: 0,           // intero REALE del backend, mai ricalcolato
            layoutSource: null,          // "DEFAULT" | "PERSONAL" | "ERROR"
            /* Sequence guard DEDICATA al layout: i reload dei filtri
               (this.sequenza) non devono invalidare una risposta del layout. */
            layoutSequenza: 0,
            /* DASH-CUSTOM-04 Stage C: OPERATION/DRAFT state (nessun dirty state).
               SERVER STATE resta sopra: layoutPersonalizzato/layoutRevision/
               layoutSource (autorevole, mai ricalcolato localmente).
               OPERATION: una sola scrittura alla volta (saving/resetting).
               DRAFT: payload del tentativo in corso, preservato su conflitto,
               errore applicativo o network failure.
               CONFLITTO: esito LAYOUT_CONFLICT + current_revision del server,
               per una futura reconciliation controllata (nessun auto-retry). */
            layoutSaving: false,
            layoutResetting: false,
            layoutDraft: null,
            layoutConflitto: null,
            /* DASH-CUSTOM-06D: EDITING STATE (distinto da SERVER e OPERATION state).
               editingDraft = clone di lavoro del layout salvato (canonical V2);
               ENTRARE in edit NON tocca il layout salvato. DASH-CUSTOM-06F: il
               rendering e' derivato dalla GRIGLIA 12 colonne (position grid
               personale, proiezione legacy o DEFAULT + compattazione). Il
               salvataggio passa SOLO da salvaLayout(),
               il reset SOLO da resetLayout(); l'esito e' certificato SOLO dallo
               stato server. */
            editMode: false,
            editingDraft: null,
            editAttesa: null,       // "salva" | "reset" | null: operazione in attesa esito
            editStatoPrima: null,   // riferimento layout pre-operazione (certificazione esito)
            editAvviso: "",
            /* DASH-CUSTOM-06F: drag HTML5 nativo sulla griglia 12 colonne.
               Nessuna lista zona: il drag muta editingDraft.widgets[id].position
               {row,column,rowSpan}. dragId = widget in trascinamento (o null). */
            dragId: null,
            /* Sequence guard: una risposta tardiva di una richiesta vecchia viene ignorata. */
            sequenza: 0,
        };
    },

    computed: {
        kpi() { return this.payload ? this.payload.kpi : null; },
        kpiDisponibile() { return this.kpi !== null && this.kpi !== undefined; },
        /* KPI-04B: blocco economico additivo. null = non presente/indisponibile.
           Le card leggono SOLO da qui; il vecchio blocco kpi resta intatto per
           gli altri consumatori e per compatibilita' del contratto. */
        economia() {
            return this.payload && this.payload.economia ? this.payload.economia : null;
        },
        economiaDisponibile() {
            return !!(this.economia && this.economia.ok === true);
        },
        trend() { return this.payload ? this.payload.trend : null; },
        heatmap() { return this.payload ? this.payload.heatmap : null; },
        stati() { return this.payload ? this.payload.stati : null; },
        rankings() { return this.payload ? this.payload.rankings : null; },
        /* UI-03: distribuzione spese per fornitore. Nessuna nuova API: e' il blocco
           spese_fornitore dello stesso contratto Dashboard. null = non disponibile. */
        speseFornitore() {
            return this.payload && this.payload.spese_fornitore ? this.payload.spese_fornitore : null;
        },
        recent() { return this.payload ? this.payload.recent : null; },
        progettiInattivi() {
            return this.payload && this.payload.progetti_inattivi ? this.payload.progetti_inattivi : null;
        },
        /* UI-02: blocco elenco progetti per la prima row (viste dello stesso payload). */
        progettiElenco() {
            return this.payload && this.payload.progetti ? this.payload.progetti : null;
        },
        /* UI-02B: il Top 10 non e' piu' montato nella prima row; il componente
           e il payload clienti_top restano disponibili. */
        clientiTop() {
            return this.payload && this.payload.clienti_top ? this.payload.clienti_top : null;
        },
        /* UI-02B: solo il NOME dell'utente (mai nome+cognome). La derivazione
           e' presentazionale, dalla sessione gia' caricata: prima il campo
           persona.NOME, altrimenti il primo token dell'USERNAME, altrimenti "".
           Nessuna nuova API, nessun valore hardcoded. */
        utenteNome() {
            const u = this.$root && this.$root.utente ? this.$root.utente : null;
            if (!u) return "";
            const p = u.persona || {};
            const nome = String(p.NOME || "").trim();
            if (nome) return nome;
            const username = String(u.USERNAME || "").trim();
            if (username) return username.split(/[.\s_]/)[0];
            return "";
        },
        /* UI-03 (chirurgia 1): AVATAR dell'utente loggato. Stessa fonte di
           utenteNome (sessione gia' caricata): nessuna nuova API. Restituisce un
           URL pronto per <img>, oppure "" quando la foto non c'e', cosi' la card
           ripiega sull'icona. Stesso criterio di App.vue / SchedaUtente /
           SchedaVisualizzazioneUtente: getImgPath('USERS', URL_AVATAR) con la
           sentinella 'placeholder.jpg'. */
        utenteAvatar() {
            const u = this.$root && this.$root.utente ? this.$root.utente : null;
            if (!u || !u.ID_UTENTE) return "";
            const url = String(u.URL_AVATAR || "").trim();
            if (!url || url === "placeholder.jpg") return "";
            /* filters e' un helper GLOBALE del progetto (main.js: global.filters),
               non una proprieta' del componente: usare this.filters produceva il
               warning Vue "Property filters was accessed during render". */
            const f = global.filters;
            return (f && typeof f.getImgPath === "function") ? f.getImgPath("USERS", url) : "";
        },
        /* B2.1B bugfix: la guardia dipendeva dai flag di caricamento, quindi con
           datiPrecedenti=true e blocco null finiva per renderizzare null.count.
           Ora dipende SOLO dalla presenza del blocco: null => non disponibile, sempre. */
        inattiviNonDisponibili() {
            return !this.progettiInattivi;
        },
        /* B2.1C-01B: stati classificati come CHIUSI, letti dal contract.
           Fonte autorevole: stati.classificazione_stati.chiusi. Nessun magic number. */
        statiChiusi() {
            const s = this.stati;
            return (s && s.classificazione_stati && Array.isArray(s.classificazione_stati.chiusi))
                ? s.classificazione_stati.chiusi : [];
        },
        mostraInattivi() {
            return this.datiPrecedenti || this.caricamento;
        },
        /* warning[] strutturati; avvisi[] legacy solo se warning[] non c'e'. */
        warningVisibili() {
            if (Array.isArray(this.warning) && this.warning.length) return this.warning;
            if (Array.isArray(this.avvisi) && this.avvisi.length) return this.avvisi;
            return [];
        },
        blocchiInErrore() {
            return this.errori.map((e) => e.blocco).filter(Boolean).join(", ");
        },
        filtriPerBarra() {
            if (this.filtri) return this.filtri;
            if (this.periodo) {
                return {
                    date_from: this.periodo.date_from,
                    date_to: this.periodo.date_to,
                    creation_active: this.periodo.creation_active ? 1 : 0,
                    creation_auto: this.periodo.creation_auto ? 1 : 0,
                    creation_from: this.periodo.creation_from || "",
                    creation_to: this.periodo.creation_to || "",
                    event_active: this.periodo.event_active ? 1 : 0,
                    event_auto: this.periodo.event_auto ? 1 : 0,
                    event_from: this.periodo.event_from || "",
                    event_to: this.periodo.event_to || "",
                    date_riferimento: this.periodo.date_riferimento || "",
                    criterio: this.periodo.criterio || "",
                    client_type: "",
                    account_id: null, client_id: null,
                    state_id: null, tipology_id: null, project_id: null,
                };
            }
            return {};
        },
        /* B2.1C-01E: il riepilogo del periodo era mostrato in ISO grezzo (YYYY-MM-DD).
           Stessa regola del pannello filtri: inglese -> MM/DD/YYYY, tutte le altre
           lingue -> DD/MM/YYYY. L'API resta sempre YYYY-MM-DD: si formatta solo
           la rappresentazione. Nessun ID lingua e' hardcodato: si legge
           $root.currentLang e si risolve il NOME dentro $root.arrayLingue. */
        linguaInglese() {
            const root = this.$root || {};
            const arr = root.arrayLingue;
            if (!Array.isArray(arr) || !arr.length) return false;
            const c = arr.find((l) => l && l.ID_GEO_STATO == root.currentLang);
            const n = c && c.NOME ? String(c.NOME).toLowerCase().trim() : "";
            return n.indexOf("ingles") === 0 || n.indexOf("english") === 0;
        },
        /* NB: in questo componente linguaInglese e formatoData sono COMPUTED (valori),
           non metodi: si usano senza parentesi. Nel pannello filtri, dove devono
           ricevere un argomento, sono invece metodi. */
        formatoData() { return this.linguaInglese ? "MM/DD/YYYY" : "DD/MM/YYYY"; },
        periodoLabel() {
            if (!this.periodo) return "";
            const intervallo = (da, a) => {
                const d = this.dataEtichetta(da);
                const f = this.dataEtichetta(a);
                return (d || da || "…") + " → " + (f || a || "…");
            };
            const parti = [];
            if (this.periodo.creation_active) {
                parti.push("Creazione: " + intervallo(this.periodo.creation_from, this.periodo.creation_to));
            }
            if (this.periodo.event_active) {
                parti.push("Evento: " + intervallo(this.periodo.event_from, this.periodo.event_to));
            }
            if (parti.length) return parti.join("  ·  ");
            return intervallo(this.periodo.date_from, this.periodo.date_to);
        },
        /* KPI-04B: le QUATTRO KPI primarie sono economiche e arrivano da
           data.economia. Ordine vincolante: Ricavi, Costi, Margine, Previsionale.
           Il blocco V1 (payload.kpi) resta nel contratto ma non alimenta piu'
           queste card. */
        kpiPrimari() {
            return [
                { chiave: "ricavi", label: "Ricavi", icona: "ph-currency-eur" },
                { chiave: "costi", label: "Costi", icona: "ph-receipt" },
                { chiave: "margine", label: "Margine", icona: "ph-chart-line-up" },
                { chiave: "previsionale", label: "Previsionale", icona: "ph-calendar-check" },
            ];
        },
        /* La griglia 2x2 della prima row mostra esattamente queste quattro card.
           Nessuna quinta card, nessuna modifica al widget 'kpi' del layout. */
        kpiPrimariQuattro() {
            return this.kpiPrimari.slice(0, 4);
        },
        /* 3 KPI secondari. Nessun ottavo KPI per riempire spazio. */
        kpiSecondari() {
            return [
                { chiave: "progetti", label: "Progetti", icona: "ph-folders" },
                { chiave: "ticket_medio_fatturato", label: "Ticket medio fatturato", icona: "ph-ticket" },
                { chiave: "ticket_medio_budget", label: "Ticket medio budget", icona: "ph-ticket" },
            ];
        },

        /* ==============================================================
         * DASH-CUSTOM-05 — rendering dinamico whitelisted
         * ============================================================== */
        /* Layout che governa il rendering: il draft SOLO in edit mode,
           altrimenti il layout salvato/default (SERVER STATE Stage B). */
        layoutAttivo() {
            return (this.editMode && this.editingDraft) ? this.editingDraft : this.layoutPersonalizzato;
        },
        /* DASH-CUSTOM-06F - posizione fissa della Welcome (SYSTEM, 5/12). */
        welcomePos() { return { row: 0, column: 0, rowSpan: 1, span: 5 }; },
        /* Widget personalizzabili ENABLED con posizione di griglia risolta:
           position grid personale, o proiezione legacy, o DEFAULT; poi
           compattazione deterministica (nessuna sovrapposizione; il layout
           salvato non viene MAI sostituito dal DEFAULT). */
        grigliaAttiva() {
            const attivo = this.layoutAttivo;
            if (!attivo || !attivo.widgets) return [];
            const w = attivo.widgets;
            let leftMax = -1, rightMax = -1;
            WIDGET_PERSONALIZZABILI.forEach((id) => {
                const p = w[id] && w[id].position;
                if (p && p.zone === 'left') leftMax = Math.max(leftMax, p.row || 0);
                else if (p && p.zone === 'right') rightMax = Math.max(rightMax, p.row || 0);
            });
            const freeOffset = Math.max(leftMax, rightMax) + 1;
            const items = WIDGET_PERSONALIZZABILI
                .filter((id) => w[id] && w[id].enabled === true)
                .map((id) => {
                    const span = this.spanWidget(id, w[id]);
                    const pos = this.risolviPosizioneGriglia(id, w[id], freeOffset);
                    return { id, span, ...pos };
                });
            return this.compattaGriglia(items);
        },
        /* Accoppia solo la disposizione DEFAULT effettiva: nessun doppio
           rendering e nessun vincolo permanente sul layout PERSONAL. */
        mostraCoppiaDestra() {
            const p = this.grigliaAttiva.find((x) => x.id === 'project_status');
            const a = this.grigliaAttiva.find((x) => x.id === 'activity');
            return !!(p && a && p.row === 0 && p.column === 5 && p.rowSpan === 2
                && a.row === 0 && a.column === 9 && a.rowSpan === 2
                && p.span === 4 && a.span === 3);
        },
        widgetSingoli() {
            return this.mostraCoppiaDestra
                ? this.grigliaAttiva.filter((x) => x.id !== 'project_status' && x.id !== 'activity')
                : this.grigliaAttiva;
        },
        /* Unico entry point: ammesso solo su stato certificato Stage B/C. */
        puoPersonalizzare() {
            if (this.editMode || this.layoutSaving || this.layoutResetting) return false;
            if (!this.layoutPersonalizzato) return false;
            return (this.layoutSource === "DEFAULT" && this.layoutRevision === 0)
                || (this.layoutSource === "PERSONAL"
                    && Number.isInteger(this.layoutRevision) && this.layoutRevision >= 1);
        },
        /* Dirty state DISTINTO dalla revision: serve solo a disabilitare un
           salvataggio inutile; la revision resta sempre quella del server.
           Confronta SOLO la vista dei 9 widget personalizzabili: welcome
           (SYSTEM UI) non deve mai rendere il draft "sporco". */
        draftDirty() {
            if (!this.editMode || !this.editingDraft || !this.layoutPersonalizzato) return false;
            return this.vistaPersonalizzabile(this.editingDraft)
                !== this.vistaPersonalizzabile(this.layoutPersonalizzato);
        },
        /* Voci del selettore widget: SOLO i 9 widget PERSONALIZZABILI
           (in_sviluppo incluso da 06F). welcome/FilterBar NON compaiono
           (SYSTEM UI). Qui si riattiva anche un widget disattivato (che non
           essendo renderizzato non ha un proprio interruttore). */
        widgetVociEdit() {
            const attivo = this.layoutAttivo;
            return WIDGET_PERSONALIZZABILI.map((id) => {
                const w = attivo && attivo.widgets ? attivo.widgets[id] : null;
                return {
                    id: id,
                    etichetta: ETICHETTE_WIDGET[id] || id,
                    abilitato: !!(w && w.enabled === true),
                };
            });
        },
    },

    watch: {
        /* Esito di SAVE/RESET Stage C certificato dallo stato server:
           riferimento nuovo + source/revision attesi. MAI revisione locale. */
        layoutSaving(nuovo, precedente) {
            if (precedente === true && nuovo === false) this.risolviEsitoEdit();
        },
        layoutResetting(nuovo, precedente) {
            if (precedente === true && nuovo === false) this.risolviEsitoEdit();
        },
        /* KPI-04B: la modale economica non deve restare aperta quando si entra
           in Personalizza. L'apertura e' gia' bloccata; qui si chiude l'edge
           case di una modale gia' visibile. */
        editMode(nuovo) {
            if (nuovo && this.kpiEconomico.aperto) this.chiudiKpiEconomico();
        },
    },

    created() {
        /* DASH-CUSTOM-04 Stage B: le due chiamate partono INDEPENDENTEMENTE.
           Nessun await, nessun waterfall: carica() resta funzionalmente
           invariata e il layout non attende i dati (e viceversa). */
        this.caricaLayout();
        this.carica();
    },


    methods: {
        apriSchedaProgetto(projectId) {
            const id = Number(projectId);
            if (!Number.isSafeInteger(id) || id <= 0) return;
            const pannello = document.getElementById('dm_project_details');
            const scheda = this.$refs.schedaVisualizzazioneProgettoDashboard;
            if (!pannello || !scheda || !globalThis.bootstrap || !globalThis.bootstrap.Offcanvas) return;
            globalThis.bootstrap.Offcanvas.getOrCreateInstance(pannello).show();
            scheda.openSchedaVisualizzazioneProgetto({ ID_PROGETTO: id });
        },
        /* B2.1C-01E: ISO -> etichetta locale. E' un METODO, non un computed:
           riceve un argomento, quindi non puo' stare tra i computed. */
        dataEtichetta(iso) {
            const m = global.moment;
            if (!m || !iso) return "";
            const d = m(String(iso), "YYYY-MM-DD", true);
            return d.isValid() ? d.format(this.formatoData) : "";
        },
        indicatoreKpi(chiave) {
            /* null = non disponibile. Non si converte mai in 0. */
            if (!this.kpiDisponibile) return null;
            const v = this.kpi[chiave];
            return v === undefined ? null : v;
        },
        /* KPI-04B: indicatore per le card economiche.
           Il valore e' ESATTAMENTE l'aggregato del backend: nessuna somma,
           nessuna percentuale e nessun arrotondamento ricalcolati qui.
           Forma compatibile con KpiCard (valore/unita/confronto_disponibile). */
        indicatoreEconomia(chiave) {
            if (!this.economiaDisponibile) return null;
            const op = this.economia.operativo;
            const prev = this.economia.previsionale;
            const mk = (valore, unita) => ({
                valore: valore,
                precedente: null,
                delta: null,
                delta_percent: null,
                confronto_disponibile: false,
                unita: unita,
            });
            if (chiave === "previsionale") {
                return prev ? mk(prev.ricavi, "EUR") : null;
            }
            /* Ricavi/Costi/Margine: se il filtro esclude l'operativo
               (es. solo PREVENTIVO) il backend dichiara applicabile=false.
               In quel caso la card mostra "Non applicabile", non zero. */
            if (!op || op.applicabile === false) return null;
            if (chiave === "ricavi") return mk(op.ricavi, "EUR");
            if (chiave === "costi") return mk(op.acquisto, "EUR");
            if (chiave === "margine") return mk(op.margine, "EUR");
            return null;
        },
        /* Percentuale aggregata del margine, letta dal backend. */
        secondarioKpi(chiave) {
            if (chiave !== "margine" || !this.economiaDisponibile) return "";
            const op = this.economia.operativo;
            if (!op || op.applicabile === false || op.percentuale_disponibile !== true) return "";
            const n = Number(op.margine_percent);
            if (!Number.isFinite(n)) return "";
            return new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(n) + "%";
        },
        /* Riga informativa della card: contesto, non un secondo importo. */
        notaKpi(chiave) {
            if (!this.economiaDisponibile) return "";
            if (chiave === "previsionale") {
                const prev = this.economia.previsionale;
                if (!prev) return "";
                const tot = Number(prev.progetti_totali || 0);
                const pre = Number(prev.progetti_preventivi || 0);
                return tot + (tot === 1 ? " progetto" : " progetti")
                    + " · " + pre + (pre === 1 ? " preventivo" : " preventivi");
            }
            const op = this.economia.operativo;
            if (!op || op.applicabile === false) return "";
            const n = Number(op.progetti || 0);
            return n + (n === 1 ? " progetto operativo" : " progetti operativi");
        },
        /* Non applicabilita' esplicita: solo per le tre KPI operative quando
           il filtro Stato seleziona esclusivamente il PREVENTIVO. */
        kpiNonApplicabile(chiave) {
            if (chiave === "previsionale" || !this.economiaDisponibile) return false;
            const op = this.economia.operativo;
            return !!(op && op.applicabile === false);
        },
        kpiEconomicoCliccabile(chiave) {
            if (this.editMode || this.layoutSaving || this.layoutResetting) return false;
            if (!this.economiaDisponibile) return false;
            return !this.kpiNonApplicabile(chiave);
        },
        apriKpiEconomico(chiave) {
            /* In Personalizza il click non apre nulla: il drag resta prioritario. */
            if (!this.kpiEconomicoCliccabile(chiave)) return;
            if (!this.economiaDisponibile) return;
            if (chiave !== "previsionale" && this.kpiNonApplicabile(chiave)) return;
            this.kpiEconomico = { aperto: true, tipo: chiave };
        },
        chiudiKpiEconomico() {
            this.kpiEconomico = { ...this.kpiEconomico, aperto: false };
        },
        /* UI-02A: tema PRESENTAZIONALE della KPI (colore pastello dell'icona).
           Non cambia dati, unita o formatter. */
        temaKpi(chiave) {
            const temi = { ricavi: "blue", costi: "red", margine: "green", previsionale: "purple" };
            return temi[chiave] || "";
        },
        toggleFiltri() {
            /* B2.1C-01B: cambia SOLO lo stato UI.
               Nessuna chiamata Dashboard, nessuna applicazione, nessun reset:
               la bozza del filtro sopravvive grazie al v-show del pannello. */
            this.filtriAperti = !this.filtriAperti;
        },
        applicaFiltri(bozza) {
            /* B2.1C-01C-B C-1 / 01D: la bozza emessa dal filtro viene USATA per
               costruire la richiesta. Prima veniva ignorata e si rispedivano i filtri
               gia' applicati: nessuna modifica raggiungeva la Dashboard.
               B2.1C-01D: verificato a runtime con Vue reale, emette 1 richiesta
               con i valori correnti della bozza. */
            if (bozza && typeof bozza === "object") {
                this.filtriDaInviare = Object.assign({}, bozza);
                this.filtriEspliciti = Object.assign({}, bozza);
            }
            /* Nessuna chiamata API allo scrittura del campo: solo qui. */
            this.carica();
        },
        /* B2.1C-01D RESET_MODE = IMMEDIATE.
           Un solo click: azzera bozza e filtri applicati, svuota il riepilogo e
           ricarica la Dashboard SENZA filtri espliciti. Il pannello resta aperto
           (lo stato del toggle non viene toccato) e non serve premere "Applica". */
        resetFiltri() {
            this.filtriDaInviare = {};
            this.filtriEspliciti = {};
            this.filtri = null;
            this.periodo = null;
            this.carica();
        },
        /* B2.2A.1-R: apre il drawer con lo stato realmente cliccato.
           NON modifica i filtri, non ricarica la Dashboard. */
        apriDrillDownStato(s) {
            if (!s || !s.state_id) return;
            this.drilldown = { stato: { state_id: s.state_id, descrizione: s.descrizione } };
        },
        chiudiDrillDown() {
            this.drilldown = { stato: null };
        },
        /* UI-07: click su una cella della heatmap -> drill del mese.
           UI-05B: la metrica selezionata nella heatmap segue nel drill, altrimenti
           la modale si aprirebbe sempre su "Fatturato" ignorando la scelta. */
        apriDrillHeatmap(mese, metrica) {
            this.heatmapDrill = {
                aperta: true,
                mese: mese,
                metrica: metrica || "fatturato",
            };
        },
        chiudiDrillHeatmap() {
            this.heatmapDrill = { ...this.heatmapDrill, aperta: false };
        },
        carica() {
            const seq = ++this.sequenza;
            this.caricamento = true;
            const args = Object.assign({}, this.filtriDaInviare);
            global.utils.get(API, args, (response) => {
                if (seq !== this.sequenza) return;   // risposta obsoleta: scartata
                this.caricamento = false;
                this.gestisciRisposta(response);
            }, false, 1);
        },
        gestisciRisposta(response) {
            /* HTTP 200 NON significa successo: l'envelope e' l'autorita'. */
            if (!response || response.esito == null) {
                this.erroreContratto = true;
                this.contractoRicevuto = null;
                return;
            }
            if (String(response.esito) !== "0") {
                /* esito != "0": errore applicativo (calcolo KO, non autorizzato, sessione). */
                this.dataStatus = "ERROR";
                this.payload = null;
                this.meta = {};
                this.erroreContratto = false;
                return;
            }
            const data = response.data || {};
            this.meta = data.meta || {};
            this.contractoRicevuto = this.meta.contract_version || null;
            /* Guard esplicito: non si interpreta silenziosamente un payload di
               versione diversa da 2.1.0. */
            if (this.contractoRicevuto !== CONTRACT_VERSION) {
                this.erroreContratto = true;
                this.payload = null;
                return;
            }
            this.erroreContratto = false;
            this.payload = data;
            this.periodo = data.periodo || null;
            this.filtri = data.filtri || null;
            this.warning = Array.isArray(data.warning) ? data.warning : [];
            this.avvisi = Array.isArray(data.avvisi) ? data.avvisi : [];
            this.errori = Array.isArray(this.meta.errori) ? this.meta.errori : [];
            this.dataStatus = this.meta.data_status || "OK";
            this.filtriDaInviare = this.filtriPerBarra;
            this.datiPrecedenti = true;
        },
        /* ==============================================================
         * DASH-CUSTOM-04 Stage B — READ path: GET theb/dashboard/layout.
         * Solo lettura: nessun POST/PUT/DELETE, nessun expected_revision,
         * nessun campo di identita', nessuna modifica al template.
         * ============================================================== */
        caricaLayout() {
            /* Sequence counter DEDICATO: i reload dei filtri (this.sequenza)
               non devono invalidare una risposta del layout in volo. */
            const seq = ++this.layoutSequenza;
            /* B.FIX: ultimo argomento true = canale opt-in: il network
               failure e' osservabile da QUI via .catch(). L'unico alert
               mostrato all'utente resta quello di utils.js. */
            let gestito = false;
            global.utils.get("theb/dashboard/layout", {}, (response) => {
                if (seq !== this.layoutSequenza) return;   // risposta obsoleta: scartata
                this.memorizzaLayoutLettura(response);
                gestito = true;
            }, false, 1, true)
            .catch(() => {
                /* Se l'handler ha gia' completato, il catch non deve MAI
                   sovrascriverlo (eccezione imprevista lungo la chain). */
                if (gestito) return;
                if (seq !== this.layoutSequenza) return;
                /* Nessun secondo alert: alert.danger spetta a utils.js. */
                this.fallisciLayout();
            });
        },
        /* Caso 1/2/3/4: validazioni SENZA throw deliberati. Ogni ramo non
           valido applica esplicitamente il fallback locale. Il metodo e'
           costruito per non generare eccezioni attese (response = dati JSON
           piatti gia' parsati da utils.js). */
        memorizzaLayoutLettura(response) {
            if (!response || typeof response !== "object") return this.fallisciLayout();
            if (String(response.esito) !== "0") return this.fallisciLayout();
            const data = response.data;
            if (!data || typeof data !== "object") return this.fallisciLayout();
            /* DASH-CUSTOM-06D: schema 1 (migrato in memoria a V2) o 2 accettati. */
            if (data.schema_version !== 1 && data.schema_version !== 2) return this.fallisciLayout();
            const source = data.source;
            if (source !== "DEFAULT" && source !== "PERSONAL") return this.fallisciLayout();
            const revision = data.revision;
            if (!Number.isInteger(revision) || revision < 0) return this.fallisciLayout();
            /* PERSONAL implica un record reale: revisione >= 1. */
            if (source === "PERSONAL" && revision < 1) return this.fallisciLayout();
            const layout = data.layout;
            if (!layout || typeof layout !== "object" || Array.isArray(layout)) {
                return this.fallisciLayout();
            }
            /* VERSION_UNSAFE (caso 3): il server risponde source=DEFAULT con
               la revisione REALE N del record incompatibile (N >= 1). La
               revisione viene CONSERVATA, MAI forzata a 0. La condizione
               "record salvato ma incompatibile" resta leggibile come
               source=DEFAULT && revision>0 (nessun quarto source inventato). */
            /* Fonte semantica UNICA: normalizer V2. Un layout V1 viene migrato
               IN MEMORIA a V2 (order/enabled preservati, span = default). */
            const norm = normalizeDashboardLayoutV2({ rawConfig: layout });
            this.layoutPersonalizzato = norm.config;
            this.layoutRevision = revision;
            this.layoutSource = source;
        },
        /* Caso 4/5: fallback locale = default MANAGER normalizzato via
           foundation. Dopo una risposta definitivamente fallita lo stato
           NON resta null. */
        fallisciLayout() {
            const norm = normalizeDashboardLayoutV2({ rawConfig: null });
            this.layoutPersonalizzato = norm.config;
            this.layoutRevision = 0;
            this.layoutSource = "ERROR";
        },
        /* ==============================================================
         * DASH-CUSTOM-04 Stage C — motore di persistenza SAVE/RESET.
         * Solo infrastruttura frontend: nessuna UI di personalizzazione,
         * nessun toggle, nessun drag & drop, nessun renderer dinamico.
         *
         * MODELLI DI STATO (distinti, mai confusi):
         *   SERVER STATE    -> layoutPersonalizzato / layoutRevision /
         *                     layoutSource (Stage B: autorevole)
         *   DRAFT STATE     -> layoutDraft (tentativo in corso, preservato)
         *   OPERATION STATE -> layoutSaving / layoutResetting / layoutConflitto
         * Concorrenza: SOLO expected_revision (integer REVISION del DB).
         * VIETATI computeRevisionToken / checkRevision (token legacy).
         * ============================================================== */
        /* SAVE — POST theb/dashboard/layout.
         * Payload ESATTAMENTE: { layout, expected_revision }.
         * Nessun campo di identita' (user_id, ID_UTENTE, FK_ID_UTENTE, role,
         * APP_KEY, app_key, DASHBOARD_KEY, dashboard_key): il server li rifiuta.
         * GUARDS: vietato se ERROR, se DEFAULT+revision>0 (VERSION_UNSAFE:
         * nessuna sovrascrittura automatica di un record incompatibile), se lo
         * stato non e' ancora caricato e se un'altra operazione e' in corso. */
        salvaLayout(draft) {
            if (this.layoutSaving || this.layoutResetting) return false;
            if (this.layoutSource === "ERROR") return false;
            if (this.layoutSource === "DEFAULT" && this.layoutRevision > 0) return false;
            if (this.layoutSource !== "DEFAULT" && this.layoutSource !== "PERSONAL") return false;
            if (!Number.isInteger(this.layoutRevision) || this.layoutRevision < 0) return false;
            if (this.layoutSource === "PERSONAL" && this.layoutRevision < 1) return false;
            /* Il layout da salvare deve essere un oggetto canonicalizzabile:
               la foundation e' totale, quindi il controllo e' sul TIPO. */
            const grezzo = (draft === undefined) ? this.layoutPersonalizzato : draft;
            if (!grezzo || typeof grezzo !== "object" || Array.isArray(grezzo)) return false;
            const norm = normalizeDashboardLayoutV2({ rawConfig: grezzo });
            if (!norm || !norm.config || typeof norm.config !== "object" || Array.isArray(norm.config)) {
                return false;
            }
            const seq = ++this.layoutSequenza;
            let gestito = false;
            this.layoutSaving = true;
            /* DRAFT: conservato PRIMA della chiamata e mai azzerato sui fallimenti. */
            this.layoutDraft = norm.config;
            global.utils.post("theb/dashboard/layout", {
                layout: norm.config,
                expected_revision: this.layoutRevision,
            }, (response) => {
                gestito = true;
                this.layoutSaving = false;
                if (seq !== this.layoutSequenza) return;   // risposta obsoleta: scartata
                this.concludiSalvataggio(response);
            }, false, 1, true)
            .catch(() => {
                /* Network failure: l'unico alert e' quello di utils.js. */
                if (gestito) return;
                this.layoutSaving = false;
                if (seq !== this.layoutSequenza) return;
                /* Nessuna mutazione: revisione e source restano quelle del
                   server; nessun successo falso; il draft resta preservato. */
            });
            return true;
        },
        /* Esito del POST: lo stato deriva SOLO dalla risposta server. */
        concludiSalvataggio(response) {
            if (!response || typeof response !== "object") return this.fallisciScrittura();
            const esito = String(response.esito);
            if (esito === "1") return this.registraErroreScrittura("salva", response);
            if (esito === "401" || esito === "999") return;   // gia' gestiti da utils.js
            if (esito !== "0") return this.fallisciScrittura();   // envelope malformato
            const data = response.data;
            /* Successo atteso: PERSONAL + revision >= 1 + schema 1 + layout.
               Qualsiasi altra cosa NON e' un successo (nessuna transizione finta). */
            if (!data || typeof data !== "object"
                || data.source !== "PERSONAL"
                || !Number.isInteger(data.revision) || data.revision < 1
                || (data.schema_version !== 1 && data.schema_version !== 2)
                || !data.layout || typeof data.layout !== "object" || Array.isArray(data.layout)) {
                return this.fallisciScrittura();
            }
            /* Riuso del validatore Stage B: assegna layoutRevision SOLO dal server. */
            this.memorizzaLayoutLettura(response);
            this.layoutDraft = null;
            this.layoutConflitto = null;
        },
        /* RESET — DELETE theb/dashboard/layout.
         * Payload ESATTAMENTE: { expected_revision }.
         * GUARDS: vietato se ERROR, se lo stato non e' caricato e se un'altra
         * operazione e' in corso. DEFAULT+revision>0 (VERSION_UNSAFE reale): il
         * reset ESPLICITO e' autorizzato dal contratto backend (resetCAS = CAS
         * sulla sola REVISION reale, api.php:497-516) e usa la revisione REALE;
         * NON avviene MAI come effetto collaterale di load/save. DEFAULT+
         * revision0 e' idempotente lato server; PERSONAL usa la sua revisione. */
        resetLayout() {
            if (this.layoutSaving || this.layoutResetting) return false;
            if (this.layoutSource === "ERROR") return false;
            if (this.layoutSource !== "DEFAULT" && this.layoutSource !== "PERSONAL") return false;
            if (!Number.isInteger(this.layoutRevision) || this.layoutRevision < 0) return false;
            if (this.layoutSource === "PERSONAL" && this.layoutRevision < 1) return false;
            const seq = ++this.layoutSequenza;
            let gestito = false;
            this.layoutResetting = true;
            global.utils.delete("theb/dashboard/layout", {
                expected_revision: this.layoutRevision,
            }, (response) => {
                gestito = true;
                this.layoutResetting = false;
                if (seq !== this.layoutSequenza) return;   // risposta obsoleta: scartata
                this.concludiReset(response);
            }, false, 1, true)
            .catch(() => {
                /* Network failure: nessuna falsa transizione a DEFAULT. */
                if (gestito) return;
                this.layoutResetting = false;
                if (seq !== this.layoutSequenza) return;
                /* Stato e draft invariati; nessun successo falso. */
            });
            return true;
        },
        /* Esito del DELETE: lo stato deriva SOLO dalla risposta server. */
        concludiReset(response) {
            if (!response || typeof response !== "object") return this.fallisciScrittura();
            const esito = String(response.esito);
            if (esito === "1") return this.registraErroreScrittura("reset", response);
            if (esito === "401" || esito === "999") return;   // gia' gestiti da utils.js
            if (esito !== "0") return this.fallisciScrittura();   // envelope malformato
            const data = response.data;
            /* Successo atteso: DEFAULT + revision 0 + schema 1 + default layout. */
            if (!data || typeof data !== "object"
                || data.source !== "DEFAULT"
                || data.revision !== 0
                || (data.schema_version !== 1 && data.schema_version !== 2)
                || !data.layout || typeof data.layout !== "object" || Array.isArray(data.layout)) {
                return this.fallisciScrittura();
            }
            this.memorizzaLayoutLettura(response);
            this.layoutDraft = null;
            this.layoutConflitto = null;
        },
        /* Risposta esito="1": conflitto esplicito o errore applicativo.
         * NESSUN retry, NESSUN overwrite, NESSUN secondo tentativo automatico,
         * NESSUNA mutazione dello stato autorevole. Il draft resta preservato. */
        registraErroreScrittura(operazione, response) {
            const data = (response && response.data && typeof response.data === "object")
                ? response.data : null;
            const codice = (data && typeof data.codice === "string") ? data.codice : null;
            if (codice === "LAYOUT_CONFLICT") {
                /* Conflitto registrato per una futura reconciliation controllata.
                   current_revision vive in layoutConflitto: layoutRevision NON
                   viene toccata (mai confondere revisione server e dirty state). */
                this.layoutConflitto = {
                    operazione: operazione,
                    current_revision: (data && Number.isInteger(data.current_revision))
                        ? data.current_revision : null,
                };
            }
            /* Un solo alert, coerente col progetto: con flg=1 utils.js non
               avvisa piu' sugli esito!=0, quindi l'avviso spetta a qui. */
            global.utils.alert.warning(
                (response && typeof response.messaggio === "string" && response.messaggio)
                    ? response.messaggio
                    : "Operazione non riuscita.");
        },
        /* Successo esito=0 non confermabile (risposta malformata o violazione
           del contratto): NESSUN successo falso. Lo stato autorevole diventa
           ignoto -> ERROR (stessa convenzione Stage B); il draft resta. */
        fallisciScrittura() {
            this.fallisciLayout();
            global.utils.alert.danger("Si è verificato un errore");
        },

        /* ==============================================================
         * DASH-CUSTOM-05/06F — modalita' "Personalizza dashboard".
         * Riusa ESCLUSIVO del motore Stage C: nessuna seconda persistence,
         * nessun POST/DELETE ad hoc, nessun retry/overwrite automatico.
         * DASH-CUSTOM-06F: griglia a 12 colonne; drag NATIVO HTML5 sui 9
         * widget personalizzabili ENABLED. WELCOME (SYSTEM UI) e' pinnata in
         * alto-sinistra, fuori dal drag, ed e' un ostacolo fisso della
         * compattazione. Il drag modifica SOLO position {row,column,rowSpan}
         * del draft; order canonico, enabled e span restano INTATTI.
         * ============================================================== */
        /* Vista STABILE dei soli 9 widget personalizzabili (ordine + ON/OFF + span
           + posizione): usata per il dirty state, cosi' welcome (SYSTEM UI) non
           interferisce. Include span e position: una modifica di larghezza o di
           posizione rende il draft "sporco" e toggle/save non perdono span/pos. */
        vistaPersonalizzabile(config) {
            const conf = (config && typeof config === "object" && !Array.isArray(config)) ? config : {};
            const ord = (Array.isArray(conf.order) ? conf.order : [])
                .filter((id) => WIDGET_PERSONALIZZABILI.includes(id));
            const w = conf.widgets || {};
            const stato = WIDGET_PERSONALIZZABILI.map((id) => {
                const on = (w[id] && w[id].enabled === true) ? 1 : 0;
                const sp = (w[id] && Number.isInteger(w[id].span)) ? w[id].span : "-";
                const pz = this.firmaPosizione(id, w[id]);
                return id + ":" + on + ":" + sp + ":" + pz;
            });
            return ord.join(",") + "|" + stato.join(",");
        },
        /* Firma posizione per il rilevamento modifiche (dirty state): deterministica
           per widget, indipendente dallo stato enabled dei fratelli. Se la
           positione e' assente usa il fallback UI-02 (stesso mapping del renderer),
           cosi' un drag che riporta un widget alla posizione originale NON rende il
           draft "sporco". */
        firmaPosizione(id, w) {
            const p = (w && w.position && typeof w.position === "object" && !Array.isArray(w.position)) ? w.position : null;
            if (p && (p.column !== undefined || p.rowSpan !== undefined)) {
                return "g:" + (Number.isInteger(p.row) && p.row >= 0 ? p.row : 0) + ":"
                    + (Number.isInteger(p.column) ? p.column : 0) + ":"
                    + (Number.isInteger(p.rowSpan) && p.rowSpan >= 1 ? p.rowSpan : 1);
            }
            if (p && ZONES.indexOf(p.zone) !== -1) return p.zone + ":" + (p.row || 0) + ":" + (p.rank || 0);
            return "default";
        },
        /* Posizione di griglia risolta: position grid personale, o proiezione
           legacy (projectZonePositionToGrid, con offset per la zona free), o
           DEFAULT. Non muta nulla; usata dal rendering. */
        risolviPosizioneGriglia(id, w, freeOffset) {
            const p = (w && w.position && typeof w.position === "object" && !Array.isArray(w.position)) ? w.position : null;
            if (p && (p.column !== undefined || p.rowSpan !== undefined)) {
                return {
                    row: (Number.isInteger(p.row) && p.row >= 0) ? p.row : 0,
                    column: Number.isInteger(p.column) ? p.column : 0,
                    rowSpan: (Number.isInteger(p.rowSpan) && p.rowSpan >= 1) ? p.rowSpan : 1,
                };
            }
            if (p && ZONES.indexOf(p.zone) !== -1) {
                const g = projectZonePositionToGrid(p);
                if (g) {
                    if (p.zone === "free") g.row = (freeOffset || 0) + g.row;
                    return g;
                }
            }
            const d = DEFAULT_MANAGER_V2_GRID_POSITIONS[id];
            return d ? { row: d.row, column: d.column, rowSpan: d.rowSpan } : { row: 0, column: 0, rowSpan: 1 };
        },
        /* Compattazione deterministica: ordina per (row,column); se un widget
           sovrappone uno gia' piazzato slitta a destra; se sfora le 12 colonne
           va a capo. Solo display: non muta il layout salvato. */
        compattaGriglia(items) {
            const inputOrder = items.slice();
            const sorted = items.slice().sort((a, b) => (a.row - b.row) || (a.column - b.column));
            /* DASH-CUSTOM-06F: Welcome SYSTEM e' un OSTACOLO FISSO (cella
               pinnata row 0, colonne 0-4): nessun widget puo' sovrapporla
               (spec 8.2 - compattazione deterministica senza sovrapposizioni). */
            const wp = this.welcomePos;
            const placed = [{ id: "welcome", span: wp.span, row: wp.row, column: wp.column, rowSpan: wp.rowSpan }];
            const byId = {};
            sorted.forEach((it) => {
                let row = it.row, col = it.column, ok = false, guard = 0;
                while (!ok && guard < 500) {
                    guard++;
                    if (col + it.span > 12) { row += 1; col = 0; continue; }
                    const clash = placed.some((o) => {
                        const rowOv = row < o.row + o.rowSpan && o.row < row + it.rowSpan;
                        const colOv = col < o.column + o.span && o.column < col + it.span;
                        return rowOv && colOv;
                    });
                    if (clash) { col += 1; continue; }
                    ok = true;
                }
                const p = { id: it.id, span: it.span, row, column: col, rowSpan: it.rowSpan };
                placed.push(p); byId[it.id] = p;
            });
            return inputOrder.map((it) => byId[it.id] || it);
        },
        /* Stile CSS-grid di una cella (grid-column / grid-row, 1-based). */
        stileCella(item) {
            if (!item) return {};
            return {
                gridColumn: (item.column + 1) + " / span " + item.span,
                gridRow: (item.row + 1) + " / span " + (item.rowSpan || 1),
            };
        },
        /* DASH-CUSTOM-06F - drag HTML5 nativo sulla griglia a 12 colonne. */
        onDragStart(e, id) {
            if (!this.editMode || this.layoutSaving || this.layoutResetting) { e.preventDefault(); return; }
            this.dragId = id;
            try { e.dataTransfer.setData("text/plain", id); e.dataTransfer.effectAllowed = "move"; } catch (_) {}
        },
        onDragEnd() { this.dragId = null; },
        onDragOver(e) {
            if (!this.editMode || !this.dragId) return;
            if (e.dataTransfer) e.dataTransfer.dropEffect = "move";
        },
        onDrop(e) {
            if (!this.editMode || !this.dragId || !this.editingDraft) return;
            const cell = this.cellaDaPunto(e.clientX, e.clientY);
            const element = e.target && typeof e.target.closest === "function"
                ? e.target.closest("[data-dm-widget]") : null;
            const targetId = element && this.$refs.dmGrid.contains(element)
                ? element.getAttribute("data-dm-widget") : null;
            const id = this.dragId;
            this.dragId = null;
            if (cell) this.spostaWidget(id, cell.row, cell.column, targetId);
        },
        /* Coordinate reali della griglia, inclusi i gap tra le celle. */
        cellaDaPunto(clientX, clientY) {
            const grid = this.$refs.dmGrid;
            if (!grid) return null;
            const rect = grid.getBoundingClientRect();
            const cs = window.getComputedStyle(grid);
            const rowGap = parseFloat(cs.rowGap) || 0;
            const columnGap = parseFloat(cs.columnGap) || 0;
            const rows = (cs.gridTemplateRows || "").split(" ").map(Number.parseFloat).filter(Number.isFinite);
            const columns = (cs.gridTemplateColumns || "").split(" ").map(Number.parseFloat).filter(Number.isFinite);
            if (!rows.length || columns.length !== 12) return null;
            const trackAt = (point, tracks, gap) => {
                let offset = 0;
                for (let i = 0; i < tracks.length; i++) {
                    if (point < offset + tracks[i] + gap / 2) return i;
                    offset += tracks[i] + gap;
                }
                return tracks.length - 1;
            };
            return {
                row: trackAt(clientY - rect.top, rows, rowGap),
                column: trackAt(clientX - rect.left, columns, columnGap),
            };
        },
        /* Sopra una card si scambiano i due spazi (posizione e dimensioni).
           Su spazio libero si sposta solo la card trascinata, senza riordinare
           gli altri widget. Tutte le modifiche restano nella bozza. */
        spostaWidget(id, row, column, targetId = null) {
            if (!this.editMode || this.layoutSaving || this.layoutResetting || !this.editingDraft) return;
            if (!Number.isInteger(row) || !Number.isInteger(column)) return;
            const widgets = this.editingDraft.widgets;
            const active = this.grigliaAttiva;
            const source = active.find((item) => item.id === id);
            if (!source || !widgets || !widgets[id]) return;
            this.editAvviso = "";
            if (targetId === id) return;
            if (targetId === "welcome") {
                this.editAvviso = "Il riquadro di benvenuto resta fisso.";
                return;
            }
            const contains = (item) => row >= item.row && row < item.row + item.rowSpan
                && column >= item.column && column < item.column + item.span;
            const target = targetId ? active.find((item) => item.id === targetId)
                : active.find((item) => item.id !== id && contains(item));
            if (targetId && !target) return;
            const overlaps = (a, b) => a.row < b.row + b.rowSpan && b.row < a.row + a.rowSpan
                && a.column < b.column + b.span && b.column < a.column + a.span;
            const moved = target
                ? { ...source, row: target.row, column: target.column, span: target.span, rowSpan: target.rowSpan }
                : { ...source, row: Math.max(0, Math.min(9999, row)),
                    column: Math.max(0, Math.min(12 - source.span, column)) };
            const changes = [moved];
            if (target) changes.push({
                ...target, row: source.row, column: source.column, span: source.span, rowSpan: source.rowSpan,
            });
            /* Non proporre dimensioni che il contratto normalizzerebbe al salvataggio. */
            if (changes.some((item) => this.spanWidget(item.id, { span: item.span }) !== item.span)) {
                this.editAvviso = "Queste card richiedono larghezze diverse: scegli uno spazio compatibile.";
                return;
            }
            const fixed = [this.welcomePos, ...active.filter((item) => !changes.some((change) => change.id === item.id))];
            if (changes.some((item) => fixed.some((other) => overlaps(item, other)))
                || (changes.length === 2 && overlaps(changes[0], changes[1]))) {
                this.editAvviso = "Spazio insufficiente: trascina sopra una card per scambiarle oppure scegli uno spazio libero.";
                return;
            }
            for (const item of changes) {
                const previous = active.find((other) => other.id === item.id);
                if (previous.row !== item.row || previous.column !== item.column
                    || previous.span !== item.span || previous.rowSpan !== item.rowSpan) {
                    widgets[item.id].span = item.span;
                    widgets[item.id].position = { row: item.row, column: item.column, rowSpan: item.rowSpan };
                }
            }
        },
        /* DASH-CUSTOM-06D — span canonico di un widget: usa lo span persistito se
           intero valido, altrimenti il defaultSpan del registry; clampato a
           [minSpan, maxSpan]. welcome (non span-capable) non entra nella griglia. */
        spanWidget(id, w) {
            const g = WIDGET_REGISTRY_V1.geometry(id);
            if (!g || !Number.isInteger(g.defaultSpan)) return 12;
            const base = (w && Number.isInteger(w.span)) ? w.span : g.defaultSpan;
            const lo = Number.isInteger(g.minSpan) ? g.minSpan : 1;
            const hi = Number.isInteger(g.maxSpan) ? g.maxSpan : 12;
            return Math.max(lo, Math.min(hi, base));
        },
        entraInEdit() {
            if (this.editMode || this.layoutSaving || this.layoutResetting) return;
            /* Stessi guard semantici del SAVE Stage C: DEFAULT+rev0 oppure
               PERSONAL+rev>=1. VERSION_UNSAFE (DEFAULT rev>0) ed ERROR restano
               fuori: niente editing su stato non certificato. */
            const ammesso = (this.layoutSource === "DEFAULT" && this.layoutRevision === 0)
                || (this.layoutSource === "PERSONAL"
                    && Number.isInteger(this.layoutRevision) && this.layoutRevision >= 1);
            if (!ammesso || !this.layoutPersonalizzato) return;
            /* Clone profondo: il saved layout NON viene mutato dall'editing. */
            this.editingDraft = JSON.parse(JSON.stringify(this.layoutPersonalizzato));
            /* welcome = SYSTEM UI: nel draft resta sempre enabled (canonical),
               ma NON e' modificabile dall'utente. */
            if (this.editingDraft.widgets && this.editingDraft.widgets.welcome) {
                this.editingDraft.widgets.welcome.enabled = true;
            }
            this.editAvviso = "";
            this.editMode = true;
        },
        /* ANNULLA: NESSUNA API, nessuna scrittura: si scarta il draft e si
           torna al layout salvato. revision/source NON vengono toccate. */
        annullaEdit() {
            this.esciDaEdit();
        },
        esciDaEdit() {
            this.editMode = false;
            this.editingDraft = null;
            this.editAttesa = null;
            this.editStatoPrima = null;
            this.editAvviso = "";
            this.dragId = null;
            /* Operazione abbandonata/conclusa: nessuna reconciliation pendente.
               (Stage C gia' azzera layoutConflitto su successo.) */
            this.layoutConflitto = null;
        },
        /* Toggle ON/OFF: muta SOLO il draft (mai il layout salvato, mai API).
           Ammesso SOLO per i widget personalizzabili: welcome (SYSTEM UI) NON
           e' toggleable. SPAN e ordine degli altri NON vengono toccati: si
           inverte `enabled`, si aggiorna la LISTA visibile (aggiunta/rimozione)
           e si ricostruisce l'ordine canonico. Cosi' un layout V2 con span
           personalizzati sopravvive INTATTO a ON/OFF + Save. */
        toggleWidgetEdit(id) {
            if (!this.editMode || !this.editingDraft || WIDGET_PERSONALIZZABILI.indexOf(id) === -1) return;
            if (this.layoutSaving || this.layoutResetting) return;
            if (!this.editingDraft.widgets) this.editingDraft.widgets = {};
            const w = this.editingDraft.widgets[id] || (this.editingDraft.widgets[id] = { enabled: true });
            const nuovo = !(w.enabled === true);
            w.enabled = nuovo;
            /* DASH-CUSTOM-06F: ON -> se il widget non ha position, riceve il
               DEFAULT di griglia (riappare nella sua cella). OFF -> esce dalla
               griglia; la position salvata resta per il ripristino esatto. */
            if (nuovo && w.position === undefined) {
                const d = DEFAULT_MANAGER_V2_GRID_POSITIONS[id];
                if (d) w.position = { row: d.row, column: d.column, rowSpan: d.rowSpan };
            }
        },
        /* SALVA: normalizzazione + salvaLayout() Stage C, nient'altro.
           Nessuna revision calcolata localmente. */
        salvaDalDraft() {
            if (!this.editMode || !this.editingDraft) return;
            if (this.layoutSaving || this.layoutResetting) return;
            this.editStatoPrima = this.layoutPersonalizzato;
            const avviato = this.salvaLayout(this.editingDraft);
            if (!avviato) {
                this.editStatoPrima = null;
                this.editAvviso = "Salvataggio non disponibile nello stato corrente del layout.";
                return;
            }
            this.editAvviso = "";
            this.editAttesa = "salva";
        },
        /* RIPRISTINA DEFAULT: azione esplicita e protetta (nessun click
           accidentale). ESCLUSIVAMENTE resetLayout() Stage C. */
        ripristinaDefault() {
            if (!this.editMode) return;
            if (this.layoutSaving || this.layoutResetting) return;
            if (!global.confirm || !global.confirm("Ripristinare il layout predefinito? Le personalizzazioni salvate verranno eliminate.")) return;
            this.editStatoPrima = this.layoutPersonalizzato;
            const avviato = this.resetLayout();
            if (!avviato) {
                this.editStatoPrima = null;
                this.editAvviso = "Ripristino non disponibile nello stato corrente del layout.";
                return;
            }
            this.editAvviso = "";
            this.editAttesa = "reset";
        },
        /* Certificazione esito: successo SOLO se lo stato server e' cambiato
           (riferimento nuovo) E source/revision sono quelle attese. Su
           conflitto si RESTA in edit con draft preservato; su errore di rete
           o applicativo lo stato invariato mantiene draft e edit mode. */
        risolviEsitoEdit() {
            const attesa = this.editAttesa;
            if (!attesa) return;
            this.editAttesa = null;
            if (!this.editMode) return;
            if (this.layoutConflitto) return;
            const cambiato = this.layoutPersonalizzato !== null
                && this.layoutPersonalizzato !== this.editStatoPrima;
            if (attesa === "salva" && cambiato && this.layoutSource === "PERSONAL") {
                this.esciDaEdit();
                return;
            }
            if (attesa === "reset" && cambiato
                && this.layoutSource === "DEFAULT" && this.layoutRevision === 0) {
                this.esciDaEdit();
                return;
            }
            this.editAvviso = attesa === "salva"
                ? "Salvataggio non riuscito: le modifiche non sono state salvate."
                : "Ripristino non riuscito: il layout non è stato modificato.";
        },
    },
}
</script>


<style scoped>
/* B2.1C-01B - apertura/chiusura del pannello filtri.
   Vue <Transition> + v-show: nessun jQuery, nessuna dipendenza.
   Si animano altezza e opacita'; max-height generoso invece di height:auto
   perche' sia animabile. overflow:hidden evita lo sfondo durante il movimento. */
.dm-filter-enter-active,
.dm-filter-leave-active {
    transition: opacity .18s ease, max-height .22s ease;
    overflow: hidden;
}
.dm-filter-enter-from,
.dm-filter-leave-to {
    opacity: 0;
    max-height: 0;
}
.dm-filter-enter-to,
.dm-filter-leave-from {
    opacity: 1;
    max-height: 40rem;
}

/* Rispetta la preferenza del sistema operativo. */
@media (prefers-reduced-motion: reduce) {
    .dm-filter-enter-active,
    .dm-filter-leave-active {
        transition: none;
    }
}
/* UI-01: il bottone Filtri avanzati mantiene testo e icona SEMPRE bianchi.
   .btn-outline-light di Bootstrap forza --btn-hover-color sul colore del tema (scuro),
   per questo al passaggio del mouse il testo diventava nero. Resta qui perche' il
   bottone e' un elemento di QUESTO template, quindi e' raggiunto dallo scope.
   UI-01A: le regole del pannello e dei controlli interni sono state spostate in
   ManagerFilterBar.vue. Vivevano qui ma puntavano al DOM del componente FIGLIO:
   il selettore compilato con il data-v del parent non le raggiungeva. */
.btn-filter-dash,
.btn-filter-dash:hover,
.btn-filter-dash:focus,
.btn-filter-dash:active,
.btn-filter-dash:focus-visible {
    color: #fff !important;
    --btn-color: #fff;
    --btn-hover-color: #fff;
    --btn-active-color: #fff;
    --btn-focus-color: #fff;
    background-image: linear-gradient(135deg, rgb(0, 123, 255) 0%, rgb(0, 92, 191) 100%) !important;
    border-color: transparent !important;
    text-shadow: none;
}
.btn-filter-dash:focus,
.btn-filter-dash:focus-visible {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, .35);
    outline: none;
}
.btn-filter-dash:active { transform: translateY(1px); }
.btn-filter-dash i,
.btn-filter-dash:hover i,
.btn-filter-dash:focus i,
.btn-filter-dash:active i { color: #fff !important; }

/* ============================================================
   UI-02C HOTFIX - allineamento altezze della prima row.
   L'altezza NON e' piu' un valore fisso: e' DERIVATA dalla colonna
   sinistra. DASH-CUSTOM-05 (correzione UX): WelcomeCard e' SYSTEM UI
   e vive FUORI dalla row, quindi l'altezza della row dipende solo
   dalla griglia KPI (riga 1 + gap + riga 2). PROJECT e ACTIVITY si
   adattano a questa altezza con scroll interno.
   ============================================================ */
@media (min-width: 1200px) {
    .ui02-row {
        --ui02-welcome-h: 250px;   /* = min-height di WelcomeCard (SYSTEM UI, fuori dalla row) */
        --ui02-kpi-h: 138px;       /* altezza uniforme delle 4 KPI (lato parent) */
        --ui02-h: calc(var(--ui02-kpi-h) + 13px + var(--ui02-kpi-h));
    }
    .ui02-kpi-grid > .col-6 {
        height: var(--ui02-kpi-h);
    }
    .ui02-col-left {
        height: var(--ui02-h);
        min-width: 0;
    }
    .ui02-col-right {
        height: var(--ui02-h);
        min-width: 0;
    }
    .ui02-col-right > .col-12,
    .ui02-col-right > .col-xl-6 {
        height: 100%;
        min-height: 0;
    }
}
/* UI-02A: gutter piu' compatti (12-14px) e gap della colonna sinistra
   coerenti; la Welcome card possiede i propri stili nel suo componente. */
.ui02-col-left {
    min-width: 0;
    gap: 13px;
}
.ui02-kpi-grid {
    min-width: 0;
    --bs-gutter-x: 13px;
    --bs-gutter-y: 13px;
}
.ui02-row.g-3 {
    --bs-gutter-x: 13px;
    --bs-gutter-y: 13px;
}

/* ============================================================
   DASH-CUSTOM-05 — modalita' personalizzazione.
   Fuori da edit mode NESSUNO di questi elementi esiste nel DOM:
   la dashboard resta identica al default/salvato. In edit mode:
   barra operazioni, drag handle e switch per widget.
   ============================================================ */
/* La zona libera usa un'unica riga Bootstrap: il gutter verticale
   replica il mb-3 delle vecchie righe statiche (parity default). */
.dm-free-flow {
    --bs-gutter-y: 1rem;
}
.dm-widget-item {
    position: relative;
    min-width: 0;
}
.dm-widget-tools {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 20;
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, .92);
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: .375rem;
    padding: 2px 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .12);
}
.dm-drag-handle {
    cursor: grab;
    color: #6c757d;
    display: inline-flex;
    padding: 2px;
    line-height: 1;
}
.dm-drag-handle:active {
    cursor: grabbing;
}
.dm-widget-tools .form-check-input {
    cursor: pointer;
}
.dm-drag-ghost {
    opacity: .5;
}
.dm-widget-menu {
    min-width: 16rem;
}

/* ============================================================
   DASH-CUSTOM-05 (correzione UX autorizzata) — WelcomeCard SYSTEM UI.
   E' fuori dal renderer dinamico; l'entry point di personalizzazione
   e' integrato in alto a destra del benvenuto.
   ============================================================ */
.dm-system-welcome {
    position: relative;
}
.dm-system-welcome-actions {
    position: absolute;
    top: .75rem;
    right: .75rem;
    z-index: 5;
}
/* Sotto 577px il pulsante compatto resta nell'intestazione Welcome. */
@media (width < 577px) {
    .ui02-kpi-grid :deep(.ui-kpi-value) {
        font-size: 1rem;
        white-space: nowrap;
    }
    .dm-personalize-label-suffix { display: none; }
    .dm-system-welcome-actions .btn {
        font-size: .75rem;
        padding: .375rem .5rem;
        white-space: nowrap;
    }
    .dm-widget--pinned:has(.dm-system-welcome-actions) :deep(.ui02-welcome-header) {
        padding-right: 8rem;
    }
}

/* ============================================================
   DASH-CUSTOM-06D — RENDERER CSS Grid (12 colonne).
   La dashboard e' un ORDINE PIATTO: le righe emergono da order + span.
   `--dm-span` e' impostata inline (= span canonico V2, gia' normalizzato e
   clampato). Tablet/mobile derivano automaticamente SENZA mutare lo span
   persistito (che resta la verita' desktop).
   ============================================================ */
/* Gap uniforme per tutta la Dashboard Manager: riferimento = distanza
   tra prima e seconda fascia (1rem = 16px). */
.dm-grid {
    --dm-gap: 8px;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: var(--dm-gap);
    margin-bottom: var(--dm-gap);
    grid-auto-rows: min-content;
}
.dm-cell { min-width: 0; position: relative; display: flex; flex-direction: column; }
.dm-cell > * { flex: 1 1 auto; min-height: 0; }
.dm-widget--pinned { z-index: 1; }
.dm-dragging { opacity: .45; }

/* Unico grid item 7/12 con due card al 50%, senza vincoli di span
   individuale applicati al loro contenitore interno. */
.dm-first-row-right {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--dm-gap);
    min-width: 0;
    width: 100%;
    align-items: stretch;
}
.dm-pair-item {
    display: flex;
    flex-direction: column;
    min-width: 0;
    position: relative;
}
.dm-pair-item > .card, .dm-pair-item > *:last-child { flex: 1 1 auto; min-width: 0; }

/* Un solo gap reale: niente margini extra sulle celle grid.
   Le KPI usano due colonne CSS anziche' i gutter/offset negativi Bootstrap,
   cosi' i bordi esterni coincidono esattamente con quelli di Welcome. */
.dm-grid .ui02-kpi-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--dm-gap);
    width: 100% !important;
    margin: 0;
    --bs-gutter-x: 0px;
    --bs-gutter-y: 0px;
}
.dm-grid .ui02-kpi-grid > .col-6 {
    width: 100%;
    max-width: none;
    padding: 0;
    margin: 0;
    min-width: 0;
}
.dm-grid > .dm-widget--pinned,
.dm-grid > .dm-widget--heatmap { margin-bottom: 0; }
/* Solo nella prima fascia: il distacco Welcome/KPI deve essere pari
   al distacco verticale tra le due file di KPI. Nessun altro widget cambia. */
@media (min-width: 1200px) {
    .dm-grid > .dm-widget--kpi { padding-top: 6px; }
}


/* ===== FIX PRIMA FASCIA (06F) ===== */
/* Welcome (pinnata row 0, col 0-4): altezza auto, bordi allineati alle KPI sottostanti */
.dm-widget--pinned { z-index: 1; }

/* KPI grid 2x2: gap uniforme ~12px (g-2 = 0.5rem = 8px, compensato sotto) */
@media (min-width: 1200px) {
    .ui02-kpi-grid { --ui02-kpi-h: 138px; }
    /* Allinea bordo sinistro/destro Welcome con griglia KPI */
    /* Il gap delle KPI e' definito una sola volta nella griglia sopra. */
}

/* Project Status + Activity (destra 7/12): altezza contenuto, no stretch artificiale */
@media (min-width: 1200px) {
    /* Le due card affiancate (project_status rowSpan=2, activity rowSpan=2)
       non devono superare l'altezza di Welcome + KPI (row 0 + row 1) */
    .dm-cell:has(> .ui02-card) { align-items: stretch; }
    .dm-cell:has(> .ui02-ap) { align-items: stretch; }
}

/* Tablet (768-1199.98px): impilamento ordinato, nessuno scroll orizzontale.
   Le coordinate persistite NON cambiano: override solo presentazionale. */
@media (max-width: 1199.98px) {
    .dm-grid .dm-cell { grid-column: 1 / -1 !important; grid-row: auto !important; }
}
/* Mobile (<768px): stack a 1 colonna, full width. */
@media (max-width: 767.98px) {
    .dm-grid { grid-template-columns: 1fr; }
    .dm-grid .dm-cell { grid-column: 1 / -1 !important; grid-row: auto !important; }
    .dm-grid .dm-first-row-right { grid-template-columns: 1fr; }
    .dm-grid .ui02-kpi-grid { grid-template-columns: 1fr; }
}
</style>
